// src/pages/LandingPage.jsx
import React, { useEffect } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Features from './components/Features';
import Audience from './components/Audience';
import SocialProof from './components/SocialProof';
import Pricing from './components/Pricing';
import Demo from './components/Demo';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Statistics from './components/Statistics';
import './LandingPage.css';

function LandingPage() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    // Observe all elements with fade-up class
    const elementsToAnimate = document.querySelectorAll('.fade-up');
    elementsToAnimate.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="landing-page-wrapper">
      <Navbar />
      <Hero />
      <Problem />
      <Solution />
      <Features />
      <Statistics />
      <Audience />
      <SocialProof />
      <Pricing />
      {/* <Demoooo /> */}
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default LandingPage;